import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../App.css";
import Sidebar from "../componenteExtra/SidebarLider"; // Asegúrate de tener un Sidebar específico para el líder
import { Toaster, toast } from "react-hot-toast";
import { GrupoContext } from "../GrupoContext";
import SessionManager from '../componenteExtra/SessionManager';

const SolicitudesAnuladasLider = () => {
  const [cancelledActivities, setCancelledActivities] = useState([]);
  const { grupo, setGrupo } = useContext(GrupoContext); // Asegúrate de tener acceso al setter del contexto

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Restaurar el estado del contexto desde localStorage
    const savedGrupo = localStorage.getItem("grupo");
    if (savedGrupo) {
      setGrupo(savedGrupo);
    }

    if (grupo) {
      fetchCancelledActivities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grupo]);

  const fetchCancelledActivities = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/cancelled_activities_by_leader/${grupo}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setCancelledActivities(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      toast.error("Error al obtener actividades anuladas");
    }
  };

  const totalActividades = cancelledActivities.length;

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Actividades anuladas - Grupo {grupo}</h1>
          <h2>Total Actividades: {totalActividades}</h2>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Código de Proyecto</th>
                  <th>Nombre Proyecto</th>
                  <th>Razón Social</th>
                  <th>Filial</th>
                  <th>Tipo de trabajo</th>
                  <th>Regulación</th>
                  <th>Socio de auditoría</th>
                  <th>Rubro GET</th>
                  <th>Nombre Actividad GET</th>
                  <th>Staff Asignado</th>
                  <th>Horas GET</th>
                  <th>Horas Estándar</th>
                </tr>
              </thead>
              <tbody>
                {cancelledActivities.map((activity, index) => (
                  <tr key={index}>
                    <td>{activity.codigo_proyecto}</td>
                    <td>{activity.nombre_proyecto}</td>
                    <td>{activity.razon_social}</td>
                    <td>{activity.filial}</td>
                    <td>{activity.tipo_solicitud}</td>
                    <td>{activity.tipo_regulacion}</td>
                    <td>{activity.encargado_auditoria}</td>
                    <td>{activity.rubro_get}</td>
                    <td>{activity.nombre_actividad_get}</td>
                    <td>{activity.staff_asignado}</td>
                    <td>{activity.horas_get}</td>
                    <td>{activity.horas_estandar}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default SolicitudesAnuladasLider;
